import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Modal, Form } from "react-bootstrap";
import { ButtonComponent, AnchorComponent } from "../elements";
import axios from "axios";
import Select from "react-select";
import { encode } from "base-64";
import { API_URL, APP_PREFIX_PATH } from "../../constant/constant";
import PaginationComponent from "../../components/PaginationComponent";
import { Row, Col } from "react-bootstrap";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import "./ClinicTable.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export default function DeletedClinicTableComponent({ thead, tbody }) {
  const { t } = useContext(TranslatorContext);
  const [clinicDetails, setClinicDetails] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedLoction, setselectedLoction] = useState([]);
  const [clinicId, setClinicId] = useState("");

  const [services, setservices] = useState([]);
  const [location, setlocation] = useState([]);
  const [Error, setError] = useState("");

  const [userData, setUserData] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [AddModal, setAddModal] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [deleteModel, setdeleteModel] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [ActiveClinic, setActiveClinic] = useState("");
  const [editclinicId, seteditClinicId] = useState("");
  const [editclinicName, seteditClinicName] = useState("");
  // const [editservice, seteditservice] = useState('');
  const [editclinicCity, seteditClinicCity] = useState("");
  const [editclinicMobile, seteditclinicMobile] = useState("");
  const [editimage, seteditimage] = useState("");
  const [editimages, seteditimages] = useState("");
  const [editabout, seteditabout] = useState("");
  const [editcommission, seteditcommission] = useState("");

  const [editclinicNameerror, seteditClinicNameerror] = useState("");
  const [editclinicCityerror, seteditClinicCityerror] = useState("");
  const [editabouterror, seteditabouterror] = useState("");
  const [editserviceError, seteditserviceError] = useState("");
  const [editclinicMobileerror, seteditclinicMobileerror] = useState("");
  const [editcommissionError, seteditcommissionError] = useState("");

  const [AddClinicName, setaddClinicName] = useState("");
  const [AddClinicCity, setAddClinicCity] = useState("");
  const [AddMultipleImg, setAddMultipleImg] = useState([]);
  const [AddImage, setAddImage] = useState("");
  const [AddLatitude, setAddLatitude] = useState("");
  const [AddLongitude, setAddLongitude] = useState("");
  const [AddAbout, setAddAbout] = useState("");
  const [AddEmail, setAddEmail] = useState("");
  const [AddMobile, setAddMobile] = useState("");
  const [AddPassword, setAddPassword] = useState("");
  const [AddCommission, setAddCommission] = useState("");

  const [AddClinicNameError, setaddClinicNameError] = useState("");
  const [AddClinicCityError, setAddClinicCityError] = useState("");
  const [AddClinicServiceError, setAddClinicServiceError] = useState("");
  const [AddImageError, setAddImageError] = useState("");
  const [AddLatitudeError, setAddLatitudeError] = useState("");
  const [AddLongitudeError, setAddLongitudeError] = useState("");
  const [AddAboutError, setAddAboutError] = useState("");
  const [AddMultipleImgError, setAddMultipleImgError] = useState("");
  const [AddEmailError, setAddEmailError] = useState("");
  const [AddMobileError, setAddMobileError] = useState("");
  const [AddPasswordError, setAddPasswordError] = useState("");
  const [AddCommissionError, setAddCommissionError] = useState("");

  const [status, setstatus] = useState("");
  const [flag, setflag] = useState("");

  const [saveEditLoading, setSaveEditLoading] = useState(false);
  const [addClinicLoading, setAddClinicLoading] = useState(false);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const entriesPerPage = 5;

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

  const filteredUsers = clinicDetails.filter((user) => {
    const lowercasedTerm = searchTerm.toLowerCase();
    return (
      user.clinic_name?.toLowerCase().includes(lowercasedTerm) ||
      user.clinic_city?.toLowerCase().includes(lowercasedTerm) ||
      user.createtime?.toLowerCase().includes(lowercasedTerm)
    );
  });

  const currentUsers = filteredUsers.slice(indexOfFirstEntry, indexOfLastEntry);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const fetchClinicDetails = () => {
    axios
      .get(API_URL + "/get_deleted_clinics")
      .then((response) => {
        setClinicDetails(response.data.clinic_arr.reverse() || []);
        // console.log(response.data.clinic_arr.reverse() || []);
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
      });
  };

  const getServices = () => {
    const user_type = localStorage.getItem("user_type");
    axios
      .post(API_URL + "/fetch_services", { user_type })
      .then((res) => {
        const formattedServices = res.data.service_arr.map((service) => ({
          label: service.service_name,
          value: service.service_id,
        }));
        setservices(formattedServices);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchClinicDetails();
    getServices();
  }, []);

  const handleUserAction = (
    action,
    clinic_id,
    clinic_name,
    clinic_city,
    about_clinic,
    active_flag,
    mobile,
    item,
    downpayment_percentage
  ) => {
    if (action === "active") {
      setActiveClinic(clinic_id);
      setstatus("activate");
      setflag(active_flag);
      setAlertModal(true);
    } else if (action === "deactive") {
      setActiveClinic(clinic_id);
      setstatus("deactivate");
      setflag(active_flag);
      setAlertModal(true);
    } else if (action === "edit") {
      // console.log('servsdkfjsklfj', service)
      seteditClinicId(clinic_id);
      seteditClinicName(clinic_name);
      seteditClinicCity(clinic_city);
      seteditabout(about_clinic);
      seteditclinicMobile(mobile);
      seteditcommission(downpayment_percentage);
      const formattedServices = item.map((service) => ({
        label: service.service_name,
        value: service.service_id,
      }));
      setSelectedServices(formattedServices);
    } else if (action == "delete") {
      setdeleteModel(true);
      setClinicId(clinic_id);
    }
  };

  const ClinicActiveDeactive = () => {
    setToggleLoading(true);
    axios
      .post(API_URL + "/activate_deactivate_clinic", {
        clinic_id: ActiveClinic,
        flag: flag,
      })
      .then((res) => {
        if (res.data.success) {
          setAlertModal(false);
          fetchClinicDetails();
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setToggleLoading(false));
  };

  const handleSaveChanges = () => {
    let hasError = false;
    if (!editclinicName || editclinicName.trim() == "") {
      seteditClinicNameerror(t("enter_clinic_name"));
      hasError = true;
    }
    if (!editclinicCity || editclinicCity.trim() == "") {
      seteditClinicCityerror(t("enter_clinic_city"));
      hasError = true;
    }
    if (!editcommission) {
      seteditcommissionError(t("enter_commission"));
      hasError = true;
    }
    if (!selectedServices) {
      seteditserviceError(t("enter_service_name"));
      hasError = true;
    }
    if (!editabout || editabout.trim() == "") {
      seteditabouterror(t("enter_about_me"));
      hasError = true;
    }
    if (!editclinicMobile) {
      seteditclinicMobileerror(t("enter_mobile"));
      hasError = true;
    }
    if (hasError) {
      return;
    }
    var services = JSON.stringify(selectedServices.map((user) => user.value));

    const formData = new FormData();
    formData.append("clinic_id", editclinicId);
    formData.append("clinic_name", editclinicName);
    formData.append("service_id", services);
    formData.append("clinic_city", editclinicCity);
    formData.append("downpayment_percentage", editcommission);
    formData.append("about_clinic", editabout);
    formData.append("mobile", editclinicMobile);
    if (editimage) {
      formData.append("image", editimage);
    }
    AddMultipleImg.forEach((file, index) => {
      formData.append("images", file);
    });

    setSaveEditLoading(true);
    axios
      .post(API_URL + "/edit_clinic", formData)
      .then((response) => {
        fetchClinicDetails();
        setEditModal(false);
        setAddMultipleImg("");
      })
      .catch((error) => {
        console.error("Error updating clinic:", error);
      })
      .finally(() => setSaveEditLoading(false));
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // add clinic
  const handleAddclinic = () => {
    let hasError = false;
    if (!AddClinicName || AddClinicName.trim() == "") {
      setaddClinicNameError(t("enter_clinic_name"));
      hasError = true;
    }
    if (!AddClinicCity || AddClinicCity.trim() == "") {
      setAddClinicCityError(t("enter_clinic_city"));
      hasError = true;
    }
    if (
      !selectedServices ||
      selectedServices == null ||
      selectedServices == " "
    ) {
      setAddClinicServiceError(t("enter_service_name"));
      hasError = true;
    }
    // if (!AddLatitude || AddLatitude.trim() == '') {
    //     setAddLatitudeError('Please enter latitude');
    //     hasError = true;
    // }
    // if (!AddLongitude || AddLongitude.trim() == '') {
    //     setAddLongitudeError('Please enter longitude');
    //     hasError = true;
    // }
    if (!AddAbout || AddAbout.trim() == "") {
      setAddAboutError(t("enter_about_me"));
      hasError = true;
    }
    if (!AddImage) {
      setAddImageError(t("upload_image"));
      hasError = true;
    }
    if (!AddEmail) {
      setAddEmailError(t("enter_your_email"));
      hasError = true;
    }
    if (!AddCommission) {
      setAddCommissionError(t("enter_commission"));
      hasError = true;
    }
    if (!AddMobile) {
      setAddMobileError(t("enter_mobile"));
      hasError = true;
    }
    if (!AddPassword) {
      setAddPasswordError(t("enter_password"));
      hasError = true;
    }

    if (hasError) {
      return;
    }
    var services = JSON.stringify(selectedServices.map((user) => user.value));

    // const data = {
    //     clinic_name: AddClinicName,
    //     clinic_city: AddClinicCity,
    //     service_id: services,
    //     latitude: AddLatitude,
    //     longitude: AddLongitude,
    //     about_clinic: AddAbout,
    //     image: AddImage,
    //     AddMultipleImg: AddMultipleImg
    // }

    const formData = new FormData();
    formData.append("clinic_name", AddClinicName);
    formData.append("clinic_city", AddClinicCity);
    formData.append("downpayment_percentage", AddCommission);
    formData.append("service_id", services);
    formData.append("email", AddEmail);
    formData.append("mobile", AddMobile);
    formData.append("password", AddPassword);

    formData.append("about_clinic", AddAbout);
    formData.append("image", AddImage);

    AddMultipleImg.forEach((file, index) => {
      formData.append("images", file);
    });

    setAddClinicLoading(true);
    axios
      .post(API_URL + "/add_clinic", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.key == "clinicExist") {
          setError(t("clinic_already_exist"));
          return;
        }
        if (response.data.success) {
          fetchClinicDetails();
          setAddModal(false);
        }
      })
      .catch((error) => {
        console.error("Error updating clinic:", error);
      })
      .finally(() => setAddClinicLoading(false));
  };

  const deleteClinic = () => {
    if (clinicId) {
      setDeleteLoading(true);
      axios
        .post(API_URL + "/delete_clinics", { clinic_id: clinicId })
        .then(() => {
          setdeleteModel(false);
          fetchClinicDetails();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => setDeleteLoading(false));
    }
  };

  return (
    <>
      <Row
        xs={1}
        sm={2}
        xl={4}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Col>
          <LabelFieldComponent
            type="search"
            // label={t('search_by')}
            icon="Search"
            placeholder={`${t("search_here")}`}
            labelDir="label-col"
            fieldSize="mb-4 w-100 h-md"
            value={searchTerm}
            onChange={handleSearch}
          />
        </Col>
      </Row>

      <div className="mc-table-responsive">
        <table className="mc-table">
          <thead className="mc-table-head primary">
            <tr>
              <th>
                <div className="mc-table-check">
                  <p>{t("sno")}</p>
                </div>
              </th>

              <th>{t("image")}</th>
              <th>{t("clinic_name")}</th>
              <th>{t("clinic_city")}</th>
              <th>{t("status")}</th>
              <th>{t("createtime")}</th>
            </tr>
          </thead>
          <tbody className="mc-table-body even">
            {currentUsers?.map((item, index) => (
              <tr key={index}>
                <td title="id">
                  <div className="mc-table-check">
                    <p>{indexOfFirstEntry + index + 1}</p>
                  </div>
                </td>

                <td title={item.clinic_name}>
                  <div className="mc-table-profile">
                    <img
                      src={
                        item.image
                          ? `${item.image}`
                          : `hospital-placeholder.webp`
                      }
                      alt="Profile"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </td>
                <td>
                  <span>{item.clinic_name || "NA"}</span>
                </td>
                <td>{item.clinic_city || "NA"}</td>
                <td>
                  <p
                    style={{
                      margin: "auto",
                      width: "80px",
                      textAlign: "center",
                    }}
                    className={
                      item.active_flag === 0
                        ? "mc-table-badge red"
                        : "mc-table-badge green"
                    }
                  >
                    {item.active_flag === 0 ? "Deactive" : "Active"}
                  </p>
                </td>
                <td>{item.createtime || "NA"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <PaginationComponent
          totalEntries={filteredUsers.length}
          entriesPerPage={entriesPerPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />

        <Modal show={editModal} onHide={() => setEditModal(false)}>
          <div className="mc-user-modal">
            <img
              src={
                userData.image
                  ? `${userData.image}`
                  : `placeholder.webp`
              }
              alt="Profile"
            />
            <h4>{userData?.name}</h4>
            <p>{userData?.email}</p>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("clinic_name")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_clinic_name")}
                value={editclinicName}
                onChange={(e) => {
                  seteditClinicName(e.target.value);
                  seteditClinicNameerror("");
                }}
              />
              <p style={{ color: "red" }}>{editclinicNameerror}</p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("clinic_city")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_clinic_city")}
                value={editclinicCity}
                onChange={(e) => {
                  seteditClinicCity(e.target.value);
                  seteditClinicCityerror("");
                }}
              />
              <p style={{ color: "red" }}>{editclinicCityerror}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("commission")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_commission")}
                value={editcommission}
                onChange={(e) => {
                  seteditcommission(e.target.value);
                  seteditcommissionError("");
                }}
              />
              <p style={{ color: "red" }}>{editcommissionError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("mobile")}</Form.Label>
              <PhoneInput
                country="kw"
                preferredCountries={["kw"]}
                value={editclinicMobile}
                onChange={(value) => {
                  seteditclinicMobile(value);
                  seteditclinicMobileerror("");
                }}
                inputStyle={{
                  width: "100%",
                  paddingLeft: "48px",
                  borderRadius: "4px",
                  border: editclinicMobileerror
                    ? "1px solid #dc3545"
                    : "1px solid #ced4da",
                }}
                placeholder={t("enter_mobile")}
                countryCodeEditable={false}
              />
              <p style={{ color: "red" }}>{editclinicMobileerror}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("clinic_service")}</Form.Label>

              <Select
                isMulti
                options={services}
                value={selectedServices}
                onChange={(e) => {
                  setSelectedServices(e);
                  seteditserviceError("");
                }}
                placeholder={t("enter_service_name")}
              />

              <p style={{ color: "red" }}>{editserviceError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("image")}</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => {
                  const file = e.target.files[0];
                  seteditimage(file);
                }}
              />
            </Form.Group>
            <Form.Group className="form-group">
              <Form.Label>{t("about_me")}</Form.Label>
              <Form.Control
                as="textarea"
                placeholder={t("enter_about_me")}
                value={editabout}
                onChange={(e) => {
                  seteditabout(e.target.value);
                  seteditabouterror("");
                }}
              />
              <p style={{ color: "red" }}>{editabouterror}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4">
              <Form.Label>{t("cover_image")}</Form.Label>
              <Form.Control
                type="file"
                multiple
                onChange={(e) => {
                  const files = Array.from(e.target.files);
                  setAddMultipleImg((prev) => [...prev, ...files]);
                  setAddMultipleImgError("");
                }}
              />
              <p style={{ color: "red" }}>{AddMultipleImgError}</p>
            </Form.Group>

            {/* Display selected images */}
            {AddMultipleImg.length > 0 && (
              <div className="selected-images">
                <h5>Selected Images:</h5>
                <div className="row">
                  {AddMultipleImg.map((file, index) => (
                    <div className="col-lg-3" key={index}>
                      <img
                        src={URL.createObjectURL(file)}
                        alt={file.name}
                        style={{
                          width: "100px",
                          height: "100px",
                          margin: "5px",
                          objectFit: "cover",
                        }} //
                      />
                      {/* {file.name} */}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setEditModal(false);
                  setAddMultipleImg("");
                }}
              >
                {t("close_popup")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className="btn btn-success"
                onClick={handleSaveChanges}
                disabled={saveEditLoading}
              >
                {saveEditLoading ? t("loading") || "Loading..." : t("save_changes")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>

        <Modal show={AddModal} onHide={() => setAddModal(false)} backdrop="static">
          <div className="mc-user-modal">
            <img
              src={`hospital-placeholder.webp`}
              alt="Profile"
            />
            <h4>{userData?.name}</h4>
            <p>{userData?.email}</p>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("clinic_name")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_clinic_name")}
                value={AddClinicName}
                onChange={(e) => {
                  setaddClinicName(e.target.value);
                  setaddClinicNameError("");
                }}
              />
              <p style={{ color: "red" }}>{AddClinicNameError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("email")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_email")}
                value={AddEmail}
                onChange={(e) => {
                  setAddEmail(e.target.value);
                  setAddEmailError("");
                }}
              />
              <p style={{ color: "red" }}>{AddEmailError}</p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("mobile")}</Form.Label>
              <PhoneInput
                country="kw"
                preferredCountries={["kw"]}
                value={AddMobile}
                onChange={(value) => {
                  setAddMobile(value);
                  setAddMobileError("");
                }}
                inputStyle={{
                  width: "100%",
                  paddingLeft: "48px",
                  borderRadius: "4px",
                  border: AddMobileError
                    ? "1px solid #dc3545"
                    : "1px solid #ced4da",
                }}
                placeholder={t("enter_mobile")}
                countryCodeEditable={false}
              />
              <p style={{ color: "red" }}>{AddMobileError}</p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("password")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_password")}
                value={AddPassword}
                onChange={(e) => {
                  setAddPassword(e.target.value);
                  setAddPasswordError("");
                }}
              />
              <p style={{ color: "red" }}>{AddPasswordError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("clinic_city")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_clinic_city")}
                value={AddClinicCity}
                onChange={(e) => {
                  setAddClinicCity(e.target.value);
                  setAddClinicCityError("");
                }}
              />
              <p style={{ color: "red" }}>{AddClinicCityError}</p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("commission")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_commission")}
                value={AddCommission}
                onChange={(e) => {
                  setAddCommission(e.target.value);
                  setAddCommissionError("");
                }}
              />
              <p style={{ color: "red" }}>{AddCommissionError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("clinic_service")}</Form.Label>

              <Select
                isMulti
                options={services}
                value={selectedServices}
                onChange={(e) => {
                  setSelectedServices(e);
                  setAddClinicServiceError("");
                }}
                placeholder={t("enter_service_name")}
              />
              <p style={{ color: "red" }}>{AddClinicServiceError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("image")}</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setAddImage(file);
                  setAddImageError("");
                }}
              />
              <p style={{ color: "red" }}>{AddImageError}</p>
            </Form.Group>

            {/* <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('latitude')}</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder={t('enter_latitude')}
                                value={AddLatitude}
                                onChange={(e) => { setAddLatitude(e.target.value); setAddLatitudeError('') }}
                            />
                            <p style={{ color: 'red' }}>{AddLatitudeError}</p>
                        </Form.Group>
                        <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('longitude')}</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder={t('enter_longitude')}
                                value={AddLongitude}
                                onChange={(e) => { setAddLongitude(e.target.value); setAddLongitudeError('') }}
                            />
                            <p style={{ color: 'red' }}>{AddLongitudeError}</p>
                        </Form.Group> */}

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("location")}</Form.Label>

              <Select
                isMulti
                options={location}
                value={selectedLoction}
                onChange={(e) => {
                  setselectedLoction(e);
                }}
                placeholder={t("select_location")}
              />
              {/* <p style={{ color: 'red' }}>{AddClinicServiceError}</p> */}
            </Form.Group>

            <Form.Group className="form-group">
              <Form.Label>{t("about_me")}</Form.Label>
              <Form.Control
                as="textarea"
                placeholder={t("enter_about_me")}
                value={AddAbout}
                onChange={(e) => {
                  setAddAbout(e.target.value);
                  setAddAboutError("");
                }}
              />
              <p style={{ color: "red" }}>{AddAboutError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4">
              <Form.Label>{t("cover_image")}</Form.Label>
              <Form.Control
                type="file"
                multiple
                onChange={(e) => {
                  const files = Array.from(e.target.files);
                  setAddMultipleImg((prev) => [...prev, ...files]);
                  setAddMultipleImgError("");
                }}
              />
              <p style={{ color: "red" }}>{AddMultipleImgError}</p>
            </Form.Group>

            {/* Display selected images */}
            {AddMultipleImg.length > 0 && (
              <div className="selected-images">
                <h5>Selected Images:</h5>
                <div className="row">
                  {AddMultipleImg.map((file, index) => (
                    <div className="col-lg-3" key={index}>
                      <img
                        src={URL.createObjectURL(file)}
                        alt={file.name}
                        style={{
                          width: "100px",
                          height: "100px",
                          margin: "5px",
                          objectFit: "cover",
                        }} //
                      />
                      {/* {file.name} */}
                    </div>
                  ))}
                </div>
              </div>
            )}
            <p style={{ color: "red" }}>{Error}</p>

            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setAddModal(false);
                  setaddClinicName("");
                  setaddClinicNameError("");
                  setAddClinicCity("");
                  setAddClinicCityError("");
                  setSelectedServices("");
                  setAddClinicServiceError("");
                  setAddImage("");
                  setAddImageError("");
                  setAddLatitude("");
                  setAddLatitudeError("");
                  setAddLongitude("");
                  setAddLongitudeError("");
                  setAddAbout("");
                  setAddAboutError("");
                  setAddMultipleImg("");
                  setAddMultipleImgError("");
                  setError("");
                  setAddEmail("");
                  setAddMobile("");
                  setAddPassword("");
                  setAddEmailError("");
                  setAddMobileError("");
                  setAddPasswordError("");
                }}
              >
                {t("close_popup")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className="btn btn-success"
                onClick={handleAddclinic}
                disabled={addClinicLoading}
              >
                {addClinicLoading ? t("loading") || "Loading..." : t("save_changes")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>

        <Modal show={alertModal} onHide={() => !toggleLoading && setAlertModal(false)}>
          <div className="mc-alert-modal">
            <i className="material-icons">new_releases</i>
            <h3>Are you sure!</h3>
            <p>Want to {status} this clinic?</p>
            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => setAlertModal(false)}
                disabled={toggleLoading}
              >
                {t("close")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className={`btn ${
                  status === "activate" ? "btn-success" : "btn-danger"
                }`}
                onClick={() => ClinicActiveDeactive()}
                disabled={toggleLoading}
              >
                {toggleLoading ? t("loading") || "Loading..." : t("Ok")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>

        <Modal show={deleteModel} onHide={() => !deleteLoading && setdeleteModel(false)}>
          <div className="mc-alert-modal">
            <i className="material-icons">new_releases</i>
            <h3>Are you sure!</h3>
            <p>Want to delete this clinic?</p>
            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => setdeleteModel(false)}
                disabled={deleteLoading}
              >
                {t("close")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className="btn btn-danger"
                onClick={() => deleteClinic()}
                disabled={deleteLoading}
              >
                {deleteLoading ? t("loading") || "Loading..." : t("Ok")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>
      </div>
    </>
  );
}
